import type { ScopeQuery } from "@app/shared"

/**
 * Serialise an app-wide {@link ScopeQuery} into a URL query string
 * (`country=<c>&vertical=<v>`), emitting only the dimensions that are
 * actually set — the `global`/`all` sentinels already collapse to
 * `undefined` upstream (see `parseScope`). Returns `""` for a fully
 * global scope so callers can append `?${qs}` conditionally.
 */
export function scopeQueryString(scope?: ScopeQuery): string {
	const params = new URLSearchParams()
	if (scope?.country) params.set("country", scope.country)
	if (scope?.vertical) params.set("vertical", scope.vertical)
	return params.toString()
}
